import { render, staticRenderFns } from "./WithdrawalHistory.vue?vue&type=template&id=71053b78&scoped=true&"
import script from "./WithdrawalHistory.vue?vue&type=script&lang=js&"
export * from "./WithdrawalHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71053b78",
  null
  
)

export default component.exports